// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.customModal {
  width: 30%;
  background: #ffffff;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

* {
  padding: 0px;
  box-sizing: border-box;
  margin: 0px;
}

/* clears the ‘X’ from Internet Explorer */
input[type=search]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

input[type=search]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the ‘X’ from Chrome */
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}

.active_title {
  color: #49a3a6 !important;
}

.active_header {
  color: #919ca7;
}

.tabs-active {
  transition: all 0.25s ease-in-out;
  border-color: #49a3a6 !important;
}
.tabs-active > span {
  color: #49a3a6 !important;
}

.main-title {
  font-family: "Open Sans Semi Bold";
  font-style: normal;
  font-size: 30px;
  line-height: 116%;
  color: #333333;
}

.options-list {
  max-height: 300px;
  overflow: scroll;
}

.fade-enter,
.fade-exit-active {
  opacity: 0;
}

.fade-exit,
.fade-enter-active {
  opacity: 1;
}

.fade-enter-active,
.fade-exit-active {
  transition: all 0.25s ease-in;
}

.slide-enter {
  opacity: 0;
  max-height: 0 !important;
}

.slide-enter-active {
  transition: max-height 300ms ease-out, opacity 200ms ease-out;
  opacity: 1;
}

.slide-exit {
  opacity: 1;
}

.slide-exit-active {
  max-height: 0 !important;
  transition: max-height 300ms ease-out, opacity 200ms ease-out;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,UAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;AAEF;;AACA;EACE,YAAA;EACA,sBAAA;EACA,WAAA;AAEF;;AACA,0CAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,SAAA;AAEF;;AAAA;EACE,aAAA;EACA,QAAA;EACA,SAAA;AAGF;;AADA,+BAAA;AACA;;;;EAIE,aAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,cAAA;AAIF;;AADA;EACE,iCAAA;EACA,gCAAA;AAIF;AAHE;EACE,yBAAA;AAKJ;;AADA;EACE,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIF;;AADA;EACE,iBAAA;EACA,gBAAA;AAIF;;AADA;;EAEE,UAAA;AAIF;;AAFA;;EAEE,UAAA;AAKF;;AAHA;;EAEE,6BAAA;AAMF;;AAHA;EACE,UAAA;EAEA,wBAAA;AAKF;;AAFA;EACE,6DAAA;EACA,UAAA;AAKF;;AAFA;EACE,UAAA;AAKF;;AAFA;EACE,wBAAA;EAEA,6DAAA;EACA,UAAA;AAIF","sourcesContent":[".customModal {\n  width: 30%;\n  background: #ffffff;\n  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n}\n\n* {\n  padding: 0px;\n  box-sizing: border-box;\n  margin: 0px;\n}\n\n/* clears the ‘X’ from Internet Explorer */\ninput[type='search']::-ms-clear {\n  display: none;\n  width: 0;\n  height: 0;\n}\ninput[type='search']::-ms-reveal {\n  display: none;\n  width: 0;\n  height: 0;\n}\n/* clears the ‘X’ from Chrome */\ninput[type='search']::-webkit-search-decoration,\ninput[type='search']::-webkit-search-cancel-button,\ninput[type='search']::-webkit-search-results-button,\ninput[type='search']::-webkit-search-results-decoration {\n  display: none;\n}\n\n.active_title {\n  color: #49a3a6 !important;\n}\n\n.active_header {\n  color: #919ca7;\n}\n\n.tabs-active {\n  transition: all 0.25s ease-in-out;\n  border-color: #49a3a6 !important;\n  > span {\n    color: #49a3a6 !important;\n  }\n}\n\n.main-title {\n  font-family: 'Open Sans Semi Bold';\n  font-style: normal;\n  font-size: 30px;\n  line-height: 116%;\n  color: #333333;\n}\n\n.options-list {\n  max-height: 300px;\n  overflow: scroll;\n}\n\n.fade-enter,\n.fade-exit-active {\n  opacity: 0;\n}\n.fade-exit,\n.fade-enter-active {\n  opacity: 1;\n}\n.fade-enter-active,\n.fade-exit-active {\n  transition: all 0.25s ease-in;\n}\n\n.slide-enter {\n  opacity: 0;\n\n  max-height: 0 !important;\n}\n\n.slide-enter-active {\n  transition: max-height 300ms ease-out, opacity 200ms ease-out;\n  opacity: 1;\n}\n\n.slide-exit {\n  opacity: 1;\n}\n\n.slide-exit-active {\n  max-height: 0 !important;\n\n  transition: max-height 300ms ease-out, opacity 200ms ease-out;\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
